import { render } from "./patient-info.vue?vue&type=template&id=02b54050&scoped=true"
import script from "./patient-info.vue?vue&type=script&lang=js"
export * from "./patient-info.vue?vue&type=script&lang=js"

import "./patient-info.vue?vue&type=style&index=0&id=02b54050&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b54050"]])

export default __exports__